import { TPushesViewCountOfItems, TPushesViewSortBy, TTypeOfModalWindow } from './pushesViewState/pushesViewContext';
import { ISoftwareUpdates, RestaurantNotificationEventType } from 'types';

export enum PushesViewActionTypes {
	SET_SOFTWARE_UPDATES = 'SET_SOFTWARE_UPDATES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_PUSH_EVENT_TYPE = 'SET_PUSH_EVENT_TYPE',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetSoftwareUpdates {
	type: PushesViewActionTypes.SET_SOFTWARE_UPDATES;
	payload: {
		softwareUpdates: ISoftwareUpdates;
	};
}

interface IChangeSearchString {
	type: PushesViewActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: string;
	};
}

interface ISetSortBy {
	type: PushesViewActionTypes.SET_SORT_BY;
	payload: {
		sortBy: TPushesViewSortBy;
	};
}

interface ISetCountOfItems {
	type: PushesViewActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: TPushesViewCountOfItems;
	};
}

interface IChangeCurrentPage {
	type: PushesViewActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: number;
	};
}

interface ISetPushEventType {
	type: PushesViewActionTypes.SET_PUSH_EVENT_TYPE;
	payload: {
		pushEventType: RestaurantNotificationEventType | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: PushesViewActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

export type TPushesViewAction =
	| ISetSoftwareUpdates
	| IChangeSearchString
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetPushEventType
	| IChangeTypeOfModalWindow;
